



















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { TableHeaderItem } from '@/utils/types'
import { Product, Promo } from '../../store/modules/lib'

import { ServerCommon } from '@/utils/ServerCommon'
import ITrash from '@/components/icons/ITrash.vue'

@Component({
  components: {
    'i-trash': ITrash,
  }
})
export default class ProductDlgLinks extends Vue {
  @Prop({ type: Object, default: {} }) protected value!: Product

  protected headers: TableHeaderItem[] = []
  protected linkTitle: string = ''
  protected linkValue: string = ''
  protected editId: string = ''

  protected addDlgState: boolean = false

  getLinkStr(link:string){
    switch (this.$vuetify.breakpoint.name) {
      case 'xs': return link.length > 10 ? link.substr(0,10)+'...' : link
      case 'sm': return link.length > 15 ? link.substr(0,25)+'...' : link
      case 'md': return link.length > 30 ? link.substr(0,35)+'...' : link
      case 'lg': return link.length > 45 ? link.substr(0,45)+'...' : link
      case 'xl': return link.length > 45 ? link.substr(0,45)+'...' : link
    }

  }

  @Watch('addDlgState')
  isAddDlgStateChanged (newValue: boolean): void {
    if (!newValue) {
      this.linkTitle = ''
      this.linkValue = ''
    }
  }

  protected edit (item: Promo): void {
    this.editId = item.id
    this.linkTitle = item.title
    this.linkValue = item.value
    this.addDlgState = true
  }

  protected save (): void {
    if ((this.linkTitle.trim() != '') && (this.linkValue.trim() != '')) {
      if (!this.editId) {
        ServerCommon.getUid()
          .then((uid: string) => {
            this.value.promo.push({
              title: this.linkTitle,
              value: this.linkValue,
              id: uid,
              order: 1,
              type: 'link'
            })
            this.value.promo = [...this.value.promo].map((v, i) => {
              v.order = i + 1

              return v
            })

            this.linkTitle = this.linkValue = ''

            this.$emit('input', this.value)
          })
          .then(() => {
            this.addDlgState = false
          })
      } else {
        this.value.promo = this.value.promo.map(v => {
          if (v.id === this.editId) {
            const link = {
              ...v,
              title: this.linkTitle,
              value: this.linkValue
            }

            return link
          }

          return v
        })

        this.$emit('input', this.value)
        this.editId = ''
        this.addDlgState = false
      }
    }
  }

  protected get items (): Promo[] {
    return this.value.promo
      .filter((promo: Promo) => promo.type == 'link')
      .sort((a:Promo, b:Promo) => {
        return a.order > b.order
          ? 1
          : (a.order < b.order)
            ? -1
            : 0;
      })
  }

  protected add () {
    this.linkTitle = ''
    this.linkValue = ''
    this.addDlgState = true
  }

  protected drop (link: Promo) {
    let value: any = this.value

    this.addDlgState = false
    this.value.promo = this.value.promo.filter((promo: Promo) => promo.id != link.id)
    this.$emit('input', value)
  }
}
